import React from 'react';
import { Flex, SafeAreaBottomSpacing, Spinner } from '@banhala/ui-kit';
import { TopGradientShadow } from './components/TopGradientShadow';

export const BottomDockedButtonSkeleton = () => {
  return (
    <Flex>
      <TopGradientShadow></TopGradientShadow>
      <Flex.Row
        alignItems={'center'}
        padding={{ horizontal: 12, vertical: 12 }}
      >
        <Flex.Row flex={1} gap={8}>
          <Flex
            flex={1}
            height={56}
            backgroundColor={'bg_tertiary'}
            borderRadius={'medium'}
            alignItems={'center'}
            justifyContent={'center'}
          >
            <Spinner size={14} color={'content_primary'} />
          </Flex>
        </Flex.Row>
      </Flex.Row>
      <SafeAreaBottomSpacing />
    </Flex>
  );
};
